import { css } from '@emotion/css'
import 'react-accessible-accordion/dist/fancy-example.css';

export const PiAccordianClass = css`
/* .accordion__button {
    background-color: #fff;
    color: #2E374A;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    text-align: left;
    border: none;

    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;

} */
/* .accordion__button::before {
    display: inline-block;
    content: '';
    height: 10px;
    width: 10px;
    margin-right: 12px;
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(-45deg);
} */
/* .accordion__button::after {
    display: inline-block;
    content: '';
    height: 10px;
    width: 10px;
    margin-right: 12px;
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(-45deg);
} */
  .css-4kplgf {
    border-radius: 8px !important;
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.12) !important;
  }
`
